export const POWERCLOUD_URL = {
  BASE: {
    PROD: 'https://ewe.powercloud.de',
    TEST: 'https://ewe-test.powercloud.de',
  },
  PATH: {
    VERTRAG: '/customers:contracts/details/{vertragsnummer}',
    AUFTRAG: '/orders/details/{auftragsnummer}',
  },
};
